import React, { useState, useEffect,useCallback } from "react";
import {
  Grid,
  TextField,
  Button,
  MenuItem,
  Avatar,
  Typography,
} from "@mui/material";
import { Toaster, toast } from "react-hot-toast";
import loginIllustration from "../images/dog.jpg"; // ภาพฝั่งซ้าย
import { useNavigate } from "react-router-dom";
import * as services from "./../services/services";


export default function CreateUser() {
    const navigate = useNavigate();
    const fetchHospital = useCallback(async () => {
      const res = await services.getHospitalList();
      setHospital(res.data.data)
    }, []);
  
    useEffect(() => {
      fetchHospital();
    }, [fetchHospital]);
  const [form, setForm] = useState({
    username: "",
    password: "",
    rePassword: "",
    name: "",
    lastname: "",
    title: "",
    phoneNumber: "",
    idCard: "",
    license_no: "",
    image: "",
    hospitalId: "",
    roleId:2
  });

  const [imagePreview, setImagePreview] = useState(null);
  const [hospitals, setHospital] = useState([]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image" && files && files[0]) {
      setForm({ ...form, image: files[0] });
      setImagePreview(URL.createObjectURL(files[0]));
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.rePassword) {
      toast.error("รหัสผ่านไม่ตรงกัน!");
      return;
    }

    try {
      const formData = new FormData();
      Object.keys(form).forEach((key) => {
        formData.append(key, form[key]);
      });

      const res = await services.register(formData);
      if (!res.data.success) throw new Error("สมัครสมาชิกไม่สำเร็จ");
      toast.success("สมัครสมาชิกสำเร็จ!");
      setForm({
        username: "",
        password: "",
        rePassword: "",
        name: "",
        lastname: "",
        title: "",
        phoneNumber: "",
        idCard: "",
        license_no: "",
        image: "",
        hospitalId: "",
        roleId: 2,

      });
      setImagePreview(null);
      navigate("/auth/login");

    } catch (error) {
      console.error(error);
      toast.error(error.message);
    }
  };

  return (
    <div className="flex min-h-screen">
      <Toaster />

      {/* ฝั่งซ้าย (ภาพประกอบ) */}
      <div
        className="hidden md:flex w-[40%] bg-cover bg-center"
        style={{ backgroundImage: `url(${loginIllustration})` }}
      ></div>

      {/* ฝั่งขวา (ฟอร์มเต็มพื้นที่) */}
      <div className="flex w-full md:w-[60%] justify-center items-center bg-white p-8">
        <form
          onSubmit={handleSubmit}
          className="w-full max-w-lg space-y-6"
        >
          {/* Avatar Upload */}
          <div className="flex flex-col items-center">
            <input
              accept="image/*"
              style={{ display: "none" }}
              id="image-upload"
              type="file"
              name="image"
              onChange={handleChange}
            />
            <label htmlFor="image-upload" className="cursor-pointer">
              <Avatar
                src={imagePreview}
                sx={{ width: 120, height: 120, marginBottom: 1 }}
              />
              <Typography variant="caption" className="text-center block">
                คลิกเพื่ออัปโหลดรูปโปรไฟล์
              </Typography>
            </label>
          </div>

          {/* Form Fields */}
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Username"
                name="username"
                value={form.username}
                onChange={handleChange}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Password"
                type="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Re-Password"
                type="password"
                name="rePassword"
                value={form.rePassword}
                onChange={handleChange}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Title"
                name="title"
                value={form.title}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="ชื่อ"
                name="name"
                value={form.name}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="นามสกุล"
                name="lastname"
                value={form.lastname}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="เบอร์โทรศัพท์"
                name="phoneNumber"
                value={form.phoneNumber}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="เลขบัตรประชาชน"
                name="idCard"
                value={form.idCard}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="เลขใบที่ใบอนุญาติ"
                name="license_no"
                value={form.license_no}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                select
                label="สังกัดโรงพยาบาล"
                name="hospitalId"
                value={form.hospitalId}
                onChange={handleChange}
                fullWidth
              >
                {hospitals.map((hospital) => (
                  <MenuItem key={hospital.id} value={hospital.id}>
                    {hospital.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>

          {/* Submit Button */}
          <div className="flex justify-center mt-6">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className="w-1/2"
            >
              สมัครใช้งาน
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
